import React from "react";

export const ButtonLoading = () => {
  return (
    <div className="spinner-border text-warning" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};
